'use client';

import * as React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { TableRow, TableCell } from '@/components/ui/table';

interface ExternalRequestsTableSkeletonProps {
  rows?: number;
}

/**
 * ExternalRequestsTableSkeleton component for displaying loading state
 * Returns only table rows to be inserted into existing table structure
 */
export function ExternalRequestsTableSkeleton({ rows = 10 }: ExternalRequestsTableSkeletonProps) {
  return (
    <SkeletonTheme baseColor="#f8fafc" highlightColor="#f1f5f9" borderRadius="0.375rem">
      <>
        {Array.from({ length: rows }, (_, index) => (
          <TableRow key={index}>
            {/* Select Checkbox */}
            <TableCell className="w-10">
              <Skeleton height={16} width={16} />
            </TableCell>

            {/* Status Badge */}
            <TableCell className="w-24">
              <Skeleton height={24} width={80} borderRadius="0.75rem" />
            </TableCell>

            {/* Request Type Badge */}
            <TableCell className="w-[110px]">
              <Skeleton height={24} width={90} borderRadius="0.75rem" />
            </TableCell>

            {/* Service Badge */}
            <TableCell className="w-[100px]">
              <Skeleton height={20} width={70} borderRadius="0.375rem" />
            </TableCell>

            {/* Event Type (two-line: type + name) */}
            <TableCell className="w-[180px]">
              <div className="flex flex-col gap-0.5 py-1">
                <Skeleton height={14} width={140} />
                <Skeleton height={12} width={100} />
              </div>
            </TableCell>

            {/* Response Status Badge */}
            <TableCell className="w-[90px]">
              <Skeleton height={20} width={50} borderRadius="0.375rem" />
            </TableCell>

            {/* Duration */}
            <TableCell className="w-[100px]">
              <Skeleton height={14} width={60} />
            </TableCell>

            {/* URL */}
            <TableCell className="w-[180px]">
              <Skeleton height={14} width={130} />
            </TableCell>

            {/* Error Message */}
            <TableCell className="w-[200px]">
              <Skeleton height={14} width={150} />
            </TableCell>

            {/* Created Date (two-line: date + year) */}
            <TableCell className="w-[120px]">
              <div className="flex flex-col gap-0.5 py-1">
                <Skeleton height={14} width={90} />
                <Skeleton height={12} width={40} />
              </div>
            </TableCell>
          </TableRow>
        ))}
      </>
    </SkeletonTheme>
  );
}

